module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/205.2edbe9ea.png";